import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
  disabled?: boolean;
}

const CivicInternalComponent = ({ disabled, values, onChange }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Corte"
          label="Corte"
          id="court"
          name="court"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.court || ''}
          onChange={(event) => {
            onChange('court', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Scala"
          label="Scala"
          id="scale"
          name="scale"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.scale || ''}
          onChange={(event) => {
            onChange('scale', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Interno1"
          label="Interno 1"
          id="firstIntern"
          name="firstIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.firstIntern || ''}
          onChange={(event) => {
            onChange('firstIntern', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Esponente interno1"
          label="Esponente interno 1"
          id="exponentFirstIntern"
          name="exponentFirstIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.exponentFirstIntern || ''}
          onChange={(event) => {
            onChange('exponentFirstIntern', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Scala esterna"
          label="Scala esterna"
          id="externalScale"
          name="externalScale"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.externalScale || ''}
          onChange={(event) => {
            onChange('externalScale', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Secondario"
          label="Secondario"
          id="secondary"
          name="secondary"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.secondary || ''}
          onChange={(event) => {
            onChange('secondary', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Interno2"
          label="Interno 2"
          id="secondaryIntern"
          name="secondaryIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.secondaryIntern || ''}
          onChange={(event) => {
            onChange('secondaryIntern', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Esponente interno2"
          label="Esponente interno 2"
          id="exponentSecondaryIntern"
          name="exponentSecondaryIntern"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.exponentSecondaryIntern || ''}
          onChange={(event) => {
            onChange('exponentSecondaryIntern', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Piano"
          label="Piano"
          id="floor"
          name="floor"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.floor || ''}
          onChange={(event) => {
            onChange('floor', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Nui"
          label="Nui"
          id="nui"
          name="nui"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.nui || ''}
          onChange={(event) => {
            onChange('nui', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Isolato"
          label="Isolato"
          id="isolated"
          name="isolated"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.isolated || ''}
          onChange={(event) => {
            onChange('isolated', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

CivicInternalComponent.displayName = 'Internal Civic residence';

const CivicInternal = memo(CivicInternalComponent);

export default CivicInternal;
